<p-popover
  #popover
  appendTo="body"
  (onShow)="centerArrow()"
>
  <ng-content />
</p-popover>
